import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Market from '@/components/Market'
import DIY from '@/components/DIY'

import Admin from '@/components/admin/Admin'
import ProjectsTable from '@/components/admin/ProjectsTable'
import ProjectsPlansTable from '@/components/admin/ProjectsPlansTable'
import OrganizationsTable from '@/components/admin/OrganizationsTable'
import OrganizationsUsersTable from '@/components/admin/OrganizationsUsersTable'
import OrganizationsProjectsTable from '@/components/admin/OrganizationsProjectsTable'
import OrganizationsUsersProjectsTable from '@/components/admin/OrganizationsUsersProjectsTable'
import UsersTable from '@/components/admin/UsersTable'
import RolesTable from '@/components/admin/RolesTable'
import PrivilegesTable from '@/components/admin/PrivilegesTable'
import PlansTable from '@/components/admin/PlansTable'
import RolesPrivilegesTable from '@/components/admin/RolesPrivilegesTable'

import Login from '@/components/Login'
import Signup from '@/components/Signup'
import Search from '@/components/Search'

import Organization from '@/components/organization/Organization'
import OrganizationPaymentHistory from '@/components/organization/OrganizationPaymentHistory'
import OrganizationUsers from '@/components/organization/OrganizationUsers'
import OrganizationPaymentMethods from '@/components/organization/OrganizationPaymentMethods'
import OrganizationRequests from '@/components/organization/OrganizationRequests'

import Settings from '@/components/settings/Settings'
import Profile from '@/components/settings/Profile'
import Notifications from '@/components/settings/Notifications'

import Help from '@/components/Help.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: '',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      children: [
        { path: 'organizations', component: OrganizationsTable },
        { path: 'organizations-users', component: OrganizationsUsersTable },
        { path: 'organizations-projects', component: OrganizationsProjectsTable },
        { path: 'organizations-users-projects', component: OrganizationsUsersProjectsTable },
        { path: 'projects', component: ProjectsTable },
        { path: 'users', component: UsersTable },
        { path: 'roles', component: RolesTable },
        { path: 'roles-privileges', component: RolesPrivilegesTable },
        { path: 'privileges', component: PrivilegesTable },
        { path: 'plans', component: PlansTable },
        { path: 'projects-plans', component: ProjectsPlansTable }
      ]
    },
    {
      path: '/organization',
      name: 'Organization',
      component: Organization,
      children: [
        { path: 'payment-history', component: OrganizationPaymentHistory },
        { path: 'users', component: OrganizationUsers },
        { path: 'payment-method', component: OrganizationPaymentMethods },
        { path: 'requests', component: OrganizationRequests }
      ]
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      children: [
        { path: 'profile', component: Profile },
        { path: 'notifications', component: Notifications }
      ]
    },
    {
      path: '/market',
      name: 'Market',
      component: Market
    },
    {
      path: '/diy',
      name: 'DIY',
      component: DIY
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js